// extracted by mini-css-extract-plugin
export var documentation = "_ie-1";
export var menu = "_ie-0";